import { isValidElement } from 'react';
import type { ReactElement } from 'react';

export const isReactElement = <Properties = unknown>(value: unknown): value is ReactElement<Properties> =>
  isValidElement(value);
